import { render, staticRenderFns } from "./Filtros.vue?vue&type=template&id=221cb264"
import script from "./Filtros.vue?vue&type=script&setup=true&lang=js"
export * from "./Filtros.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports